import Image2 from "../images/pic2.png";
import foodLogo from "../images/food-logo.png";

function Section3() {
  const foodClick = () => {
    window.open("https://discoverycamps.org/camp-discovery/", "_blank");
  };
  return (
    <div className="flex flex-col md:flex-row">
      <div className="md:w-1/2 flex items-center justify-center">
        <img
          src={Image2}
          alt="Joyful moment"
          className="w-full h-full object-cover object-center md:min-h-[100%] min-h-[100vw]"
        />
      </div>
      <div className="bg-[#FEB725] text-[#2F2F2F] md:w-1/2">
        <div className="flex flex-col text-center md:text-left gap-8 xl:gap-12 py-12 md:py-20 xl:py-32 px-6 md:px-16 xl:px-32">
          {/* <img
            src={foodLogo}
            alt="Food Bank Logo"
            className="food-logo w-[250px] md:w-[370px]"
          /> */}
          <div className="font-montserrat text-[39px] md:text-5xl xl:text-[72px] leading-[1.3]">
            Bring a Little Joy
          </div>
          <div className="font-montserrat text-[22px] md:text-[28px] leading-[1.7]">
            There is nothing like bringing happiness to the lives of children
            and families battling cancer. Learn more about Camp Discovery and
            other ways you can help.
          </div>
          <button
            className="secondary-donate-btn mx-auto md:mx-0 md:mt-4 uppercase"
            onClick={foodClick}
          >
            CAMP DISCOVERY
          </button>
        </div>
      </div>
    </div>
  );
}

export default Section3;
